import { defineBlock, EditableText, useInlineEditableValue } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Anchor",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/anchor", (props) => {
  const [anchorId] = useInlineEditableValue("anchorId", "")
  return env.admin ? (
    <div className="w-full border-current border-2 border-dashed p-5 flex gap-4">
      <span className="type-label-s-caps">Anchor:</span>
      <EditableText store="anchorId" className="type-label-s-caps" placeholder="Enter Anchor ID" />
    </div>
  ) : (
    <a id={anchorId} className="block w-full h-0"></a>
  )
})
